export class PortfolioAssignmentsResultDto {
    managementCompanyName: string;
    locationName: string;
    communityId: number;
    communityName: string;
    businessRoleTitle: string;
    businessRoleHelpKey: string;
    isPrimary: boolean;
    isSecondary: boolean;
}
